import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Acceuil from './pages/Acceuil';
import NosSolutions from './pages/NosSolutions';
import QuiSommeNous from './pages/QuiSommesNous';
import Carrieres from './pages/Carrieres';
import ContactezNous from './pages/ContactezNous';
import HamburgerIcon from './img/icon-hamburger.svg';
// import { FooterMenu } from './components/MainComponents';

function App() {
  const currentYear = new Date().getFullYear();

  const [footermobile, setFootermobile] = useState(false)

  useEffect(() => {

    const handleResize = () => {
      if (window.innerWidth < 600) {
        setFootermobile(true);
      } else {
        setFootermobile(false)
      }

    }

    handleResize();
    window.addEventListener("resize", handleResize);

  }, [window.innerWidth]);
  const handleNavLinkClick = () => {
    const navbar = document.getElementById("myNavbar");
    if (navbar) {
      navbar.classList.remove("in"); // Bootstrap v3
      navbar.classList.remove("show"); // Bootstrap v5+
      navbar.classList.add("collapse");
    }
  };

  return (
    <Router>
      <div class="navbar-fixed-top mynavbar-color">
      <div className="navbar-fixed-top mynavbar-color">
  <div className="navbar-header">
    <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
      <img style={{ width: "30px" }} src={HamburgerIcon} alt="Menu" />
    </button>
    <Link className="brand" to="/"><img className="logoHeader" src={require("./img/Pro-P-Logo.png")} alt="" /></Link>
  </div>
  <div className="collapse navbar-collapse mynavbar" id="myNavbar">
    <div className="nav navbar-nav navbar-right text-center">
      <Link id="nav-acceuil" className="linkItem navSelected" to="/" onClick={() => { document.documentElement.scrollTop = 0; handleNavLinkClick(); }}>Accueil</Link><hr className="nav-hr" />
      <Link id="nav-quisommenous" className="linkItem" to="/quiSommeNous" onClick={() => { document.documentElement.scrollTop = 0; handleNavLinkClick(); }}>Qui sommes-nous</Link><hr className="nav-hr" />
      <Link id="nav-nosolutions" className="linkItem" to="/nosSolutions" onClick={() => { document.documentElement.scrollTop = 0; handleNavLinkClick(); }}>Nos solutions</Link><hr className="nav-hr" />
      <Link id="nav-carrieres" className="linkItem" to="/carrieres" onClick={() => { document.documentElement.scrollTop = 0; handleNavLinkClick(); }}>Carrières</Link><hr className="nav-hr" />
      <Link id="nav-contactez" className="linkItem" to="/contactezNous" onClick={() => { document.documentElement.scrollTop = 0; handleNavLinkClick(); }}>Contactez-nous</Link>
    </div>
  </div>
</div>
        <div class="collapse navbar-collapse mynavbar" id="myNavbar">
          <div class="nav navbar-nav navbar-right text-center">
            <Link id='nav-acceuil' class="linkItem navSelected" to="/" onClick={() => { document.documentElement.scrollTop = 0 }}>Accueil</Link>
            <hr class="nav-hr" />
            <Link id='nav-quisommenous' class="linkItem" to="/quiSommeNous" onClick={() => { document.documentElement.scrollTop = 0 }}>Qui sommes-nous</Link>
            <hr class="nav-hr" />
            <Link id='nav-nosolutions' class="linkItem" to="/nosSolutions" onClick={() => { document.documentElement.scrollTop = 0 }}>Nos solutions</Link>
            <hr class="nav-hr" />
            <Link id='nav-carrieres' class="linkItem" to="/carrieres" onClick={() => { document.documentElement.scrollTop = 0 }}>Carrières</Link>
            <hr class="nav-hr" />
            <Link id='nav-contactez' class="linkItem" to="/contactezNous" onClick={() => { document.documentElement.scrollTop = 0 }}>Contactez-nous</Link>
          </div>
        </div>
      </div>
      <Routes>
        <Route path='/' element={<Acceuil />} />
        <Route path='/nosSolutions' element={<NosSolutions />} />
        <Route path='/quiSommeNous' element={<QuiSommeNous />} />
        <Route path='/carrieres' element={<Carrieres />} />
        <Route path='/contactezNous' element={<ContactezNous />} />
      </Routes>

      {/* <FooterMenu /> */}
      <div id="contact" class="container-fluid bg-bluecode footerContainer" >
        
        <div class="ft-ct">
          <div class=" ft-col1">
            <div class="ft-col1-div">
              <img class="logoFooter" src={require("./img/Logo-white.png")} alt="" />
            </div>
             <div>
            <Link id='nav-contactez1' to="/contactezNous" className='ft-logo-link' onClick={() => { document.documentElement.scrollTop = 0 }}><div>Contactez-nous</div> <div><i class="fas fa-long-arrow-alt-right ft-icon-cn"></i></div></Link>
            </div>
          </div>

          <div class=" ft-col2">
            <div class="ft-col2-div">
              <div class="ft-col2-ct ft-col2-div2">
                <div class="ft-col2-location cursor-pointer map-info-hover icon-info-flex" onClick={() => { window.open('https://goo.gl/maps/V3MPhmjuf3brgYo8A', '_blank'); }}>
                  <i class="footer-icons fa fa-map-marker fa-fw" aria-hidden="true"></i>
                  <p class="mapinfo-p3">Zgharta, Lebanon</p>
                </div>
                <div class="ft-col2-linkedin cursor-pointer map-info-hover icon-info-flex" onClick={() => { window.open('https://www.linkedin.com/company/pro-p-group/about/', '_blank'); }}>
                  <i class="footer-icons fa fa-linkedin-square fa-fw" aria-hidden="true"></i>
                  <p class="mapinfo-p3">Pro-P Group</p>
                </div>
                <div class="ft-col2-phonelb cursor-pointer map-info-hover icon-info-flex" onTouchStart={() => { window.open('tel:0096106669064'); }}>
                  <div>
                    <i class="footer-icons fa fa-phone fa-fw" style={{ transform: "rotate(90deg)" }} aria-hidden="true"></i>
                  </div>
                  <div>
                    <p class="mapinfo-p3">+961 6 669 064</p>
                  </div>
                </div>
                <div class="ft-col2-phonefr cursor-pointer map-info-hover icon-info-flex" onTouchStart={() => { window.open('tel:0033189162720'); }}>

                  <div>
                    <i class="footer-icons fa fa-phone fa-fw" style={{ transform: "rotate(90deg)" }} aria-hidden="true"></i>
                  </div>
                  <div>
                    <p class="mapinfo-p3">+33 1 89 16 27 20</p>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="ft-col3">
            <Link id='nav-acceuil1' class='ftTitleHover col-sm-12' to="/" onClick={() => { document.documentElement.scrollTop = 0 }}>Accueil</Link>
            <Link id='nav-quisommenous1' to="/quiSommeNous" className='ftTitleHover col-sm-12' onClick={() => { document.documentElement.scrollTop = 0 }}>Qui sommes-nous</Link>
            <Link id='nav-nosolutions1' to="/nosSolutions" className='ftTitleHover col-sm-12' onClick={() => { document.documentElement.scrollTop = 0 }}>Nos Solutions</Link>
            <Link id='nav-carrieres1' to="/carrieres" className='ftTitleHover col-sm-12' onClick={() => { document.documentElement.scrollTop = 0 }}>Carrières</Link>
            {/* {footermobile && 
            <Link id='nav-contactez1' to="/contactezNous" className='ftTitleHover col-sm-12' onClick={() => { document.documentElement.scrollTop = 0 }}>Contactez-nous</Link>} */}
          </div>
        </div>
      </div>
      <footer class="alignCenter fullSize">
        <p class="color-blue footer-p">{currentYear} © Pro-P Group. All rights reserved.</p>
      </footer>

    </Router>
  );
}

export default App;
